import React, { useState } from 'react';
import type { LabelElement } from 'models/forms/formElements/LabelElement';

type Props = {
  element: LabelElement;
  isEditing: boolean;
  onUpdate: (updatedElement: LabelElement) => void;
};

const LabelElementComponent: React.FC<Props> = ({ element, isEditing, onUpdate }) => {
  const [text, setText] = useState(element.value || '');

  if (isEditing) {
    return (
      <div>
        <p className="mb-1 text-sm text-gray-700">Label text</p>
        <input
          type="text"
          value={text}
          onChange={(e) => {
            const next = e.target.value;
            setText(next);
            onUpdate({ ...element, value: next });
          }}
          className="block w-full px-3 py-2 border border-gray-300 rounded"
        />
      </div>
    );
  }

  return (
    <div className="text-sm text-gray-700">
      {element.value}
    </div>
  );
};

export default LabelElementComponent;
